import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Typography, } from "@mui/material";
import React from "react";
import HTMLEllipsis from "react-lines-ellipsis/lib/html.js";
import { useElementSize } from "../hooks/useElementSize.js";
export const TruncatedHtmlValue = ({ lines = 3, html, textProps, notSetLabel, showMoreLabel, showLessLabel, buttonProps, }) => {
    const [showMore, setShowMore] = React.useState(false);
    const [hasTruncatedText, setHasTruncatedText] = React.useState(false);
    const sizeMeasureRef = React.useRef(null);
    const size = useElementSize(sizeMeasureRef);
    return (_jsxs(Typography, { component: "div", className: "msys-markup-text-html", ref: sizeMeasureRef, ...textProps, sx: [
            ...(!html?.trim() ? [{ color: "grey.500" }] : []),
            ...(Array.isArray(textProps?.sx) ? textProps.sx : [textProps?.sx]),
        ], children: [_jsx(HTMLEllipsis, { unsafeHTML: html?.trim() ? html : `<p>${notSetLabel}</p>`, maxLine: showMore ? 999 : lines, ellipsis: "\u2026", basedOn: "words", onReflow: ({ clamped, text }) => {
                    if (!showMore && clamped && !hasTruncatedText)
                        setHasTruncatedText(true);
                    if (!showMore && !clamped && hasTruncatedText)
                        setHasTruncatedText(false);
                }, winWidth: size.width }, `html-ellipsis-${showMore ? 999 : lines}`), hasTruncatedText &&
                (!showMore ? (_jsx(Button, { onClick: () => setShowMore(true), variant: "text", color: "secondary", size: "extra-small", ...buttonProps, children: showMoreLabel })) : (_jsx(Button, { onClick: () => setShowMore(false), variant: "text", color: "secondary", size: "extra-small", ...buttonProps, children: showLessLabel })))] }));
};
//# sourceMappingURL=TruncatedHtmlValue.js.map